import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { TagComponent } from '../types/Components';

/**
 * A tag component added by the TurnSystem when an actor has enough energy to act.
 * It is consumed by the AISystem or InputSystem.
 */
class WantsToAct extends Component implements TagComponent {}

export default simpleComponent(WantsToAct);
